import { CREATE_ACCOUNT_SESSION_MUTATION } from './GraphQlQuery/AccountGraphqlQueries';
import type { AccountSessionResult, CreateAccountSessionInput } from './Type/AccountTypes';
import { pokerGraphqlRequest } from '../Utils/PokerGraphqlClient';

export const createAccountSession = async (args: {
  input?: CreateAccountSessionInput;
  signal?: AbortSignal;
}): Promise<AccountSessionResult> => {
  const res = await pokerGraphqlRequest<
    { createAccountSession: AccountSessionResult },
    { input?: CreateAccountSessionInput }
  >({
    query: CREATE_ACCOUNT_SESSION_MUTATION,
    variables: args.input ? { input: args.input } : undefined,
    signal: args.signal,
  });

  return res.createAccountSession;
};
